import { Loader, PageHeader } from '@fukuri-admins/ui/common';
import { Suspense } from 'react';
import { ContractPlanList } from '~/features/ContractPlanList';
import styles from './styles.module.scss';

/**
 * 契約プラン一覧 Screen
 *
 * NOTE: ContractPlanList Feature は Suspense 境界内でレンダーする
 */
export const Screen: React.FC = () => {
  return (
    <>
      <PageHeader variant='title' title='契約プラン一覧' />
      <main className={styles.body}>
        <Suspense fallback={<Loader />}>
          <ContractPlanList />
        </Suspense>
      </main>
    </>
  );
};
